import { Spin } from 'antd';
import moment from 'moment';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import Content from './Content';
import Header from './Header';

import { TYPE } from '@/constants/appDiscountHistory';
import { QueryKey } from '@/constants/queryKey';
import { AppDiscountHistoryFilter } from '@/dto/requestDto';
import LayoutContent from '@/layout/Content';
import appDiscountHistoryService from '@/services/app-discount-history.service';
import { handleMessageError } from '@/util/handleMessageError';
import { joinBreadcrumbLabel } from "@/util/joinBreadcrumbLabel";

const IssuedTicket = () => {
    const { t } = useTranslation(['common', 'ticket']);
    const defaultFilters: AppDiscountHistoryFilter = {
        type: TYPE.TICKET,
        currentPage: 1,
        name: null,
        pageSize: 10,
        issuedAtFrom: null,
        issuedAtTo: null
    };
    const [filter, setFilter] = useState<AppDiscountHistoryFilter>(defaultFilters);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);

    const { isLoading, refetch } = useQuery([QueryKey.appDiscountHistory, filter], () => appDiscountHistoryService.getAll(filter), {
        enabled: false,
        onSuccess: (response) => {
            if (response?.data) {
                setData(response.data);
                setTotal(response.pageResult?.total || 0);
            } else {
                setData([]);
                setTotal(0);
            }
        },
        onError: (error: any) => {
            handleMessageError(error, t);
        },
    });

    useEffect(() => {
        refetch();
    }, []);

    const onHandleFilter = (data: any) => {
        const filter: AppDiscountHistoryFilter = {
            type: TYPE.TICKET,
            name: data?.name || null,
            issuedAtFrom: data?.date?.[0] ? moment(data.date[0]).format('YYYY-MM-DD') : null,
            issuedAtTo: data?.date?.[1] ? moment(data.date[1]).format('YYYY-MM-DD') : null,
            currentPage: 1,
            pageSize: 10,
        };
        setFilter(filter);
    };

    const onChangePage = (page: number, pageSize: number) => {
        setFilter({ ...filter, currentPage: page, pageSize });
    };

    const onHandleClearData = () => {
        setFilter(defaultFilters);
    };

    useEffect(() => {
        if (filter) {
            refetch();
        }
    }, [filter]);

    return (
        <LayoutContent
            className="p-ticket"
            title={joinBreadcrumbLabel([t('APP_MANAGEMENT'), t('TICKET_MANAGEMENT'), t('ticket:TAB_ISSUE_HISTORY')])}
        >
            <Header onClearData={onHandleClearData} onHandleData={onHandleFilter} />
            <Spin spinning={isLoading}>
                <Content
                    data={{
                        data: data,
                        pageResult: {
                            currentPage: filter.currentPage || 1,
                            pageSize: filter.pageSize || 10,
                            total: total,
                        },
                    }}
                    onChangePage={onChangePage}
                    filter={filter}
                    fetchData={refetch}
                />
            </Spin>
        </LayoutContent>
    );
};

export default IssuedTicket;
